<template>
	<div class="nobox">
		<div class="block-title">费用统计</div>
		<div id="" class="">
			<!-- <div id="fb03" ref="chartDiv1" style="float: left; width: 50%; height: 250px"></div> -->
			<div id="fb04" ref="chartDiv2" style="float: left; width: 100%; height: 250px"></div>
		</div>
	</div>
</template>
<script>
	import * as echarts from 'echarts';

	export default {
		data() {
			return {
				chargeWayChart: null,
				costChart: null,
				ChargeWay: {},
			}
		},
		mounted() {
			// this.chargeWayChart = echarts.init(this.$refs.chartDiv1);
			// this.chargeWayChart.setOption(chargeWayChartOption);
			this.costChart = echarts.init(this.$refs.chartDiv2);
			this.costChart.setOption(costChartOption);
			window.addEventListener('resize', () => {
				// this.chargeWayChart.resize();
				this.costChart.resize();
			});
		},
		methods: {
			setData(data) {
				this.ChargeWay = data;

				// chargeWayChartOption.series[0].data[0].value = data.ChargeCardNum;
				// chargeWayChartOption.series[0].data[1].value = data.WeixinMpNum;
				// chargeWayChartOption.series[0].data[2].value = data.WeixinMiniNum;
				// chargeWayChartOption.series[0].data[3].value = data.EvcsNum;
				// this.chargeWayChart.setOption(chargeWayChartOption);

				costChartOption.series[0].data[0].value = data.ChargeCostElec;
				costChartOption.series[0].data[1].value = data.ChargeCostService;
				// costChartOption.series[0].data[2].value =
				// 	data.ChargeCostOccupy === 0
				// 		? Math.round((data.ChargeCostElec + data.ChargeCostService) * 3) * 0.01
				// 		: data.ChargeCostOccupy;
				this.costChart.setOption(costChartOption);
			}
		}
	}

	// let chargeWayChartOption = {
	//   color: ['#BDF090', '#4DCEF8', '#6C92F8', '#FF9F7F'],
	//   title: {
	//     text: '充电方式',
	//     left: '33%',
	//     top: 'middle',
	//     textAlign: 'center',
	//     textStyle: { color: 'white', fontSize: 14 },
	//   },
	//   tooltip: {
	//     trigger: 'item',
	//     formatter: '{a} <br/>{b}: {c} ({d}%)',
	//   },
	//   legend: {
	//     orient: 'vertical',
	//     right: 10,
	//     top: 'middle',
	//     data: ['充电卡', '微信公众号', '微信小程序', '互联互通'],
	//     itemWidth: 18,
	//     itemHeight: 12,
	//     textStyle: {
	//       color: '#929ca8',
	//       fontSize: 10,
	//     },
	//   },
	//   series: [
	//     {
	//       name: '充电方式',
	//       type: 'pie',
	//       radius: ['35%', '45%'],
	//       center: ['35%', '50%'],
	//       // avoidLabelOverlap: false,
	//       label: {
	//         show: false,
	//         position: 'outside',
	//         formatter: '{b} ({c})',
	//         textShadowColor: 'transparent',
	//         textShadowBlur: 0,
	//       },
	//       data: [
	//         { value: 0, name: '充电卡' },
	//         { value: 0, name: '微信公众号' },
	//         { value: 0, name: '微信小程序' },
	//         { value: 0, name: '互联互通' },
	//       ],
	//     },
	//   ],
	// };
	let costChartOption = {
		color: ['#BDF090', '#4DCEF8', '#BBBBBB', '#FF9F7F'],
		title: {
			text: '充电费用',
			left: '54%',
			top: 'middle',
			textAlign: 'center',
			textStyle: {
				color: 'white',
				fontSize: 14
			},
		},
		tooltip: {
			trigger: 'item',
			formatter: '{a} <br/>{b}: {c} ({d}%)',
		},
		legend: {
			orient: 'vertical',
			left: 10,
			top: 'top',
			data: ['充电电费', '充电服务费'],
			itemWidth: 18,
			itemHeight: 12,
			textStyle: {
				color: '#929ca8',
				fontSize: 10,
			},
		},
		series: [{
			name: '充电费用',
			type: 'pie',
			radius: ['35%', '50%'],
			center: ['55%', '50%'],
			// avoidLabelOverlap: false,
			label: {
				show: true,
				position: 'outside',
				color: '#eee',
				formatter: '{b} ({c})',
			},
			data: [{
					value: 0,
					name: '充电电费'
				},
				{
					value: 0,
					name: '充电服务费'
				},
				// { value: 0, name: '占桩费' },
			],
		}, ],
	};
</script>
<style scoped>
	@import '../style.css';
</style>